import { render, staticRenderFns } from "./person-withdrawal-record.vue?vue&type=template&id=205fd6fb&scoped=true"
import script from "./person-withdrawal-record.vue?vue&type=script&lang=js"
export * from "./person-withdrawal-record.vue?vue&type=script&lang=js"
import style0 from "./person-withdrawal-record.vue?vue&type=style&index=0&id=205fd6fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fd6fb",
  null
  
)

export default component.exports